<dynamic-form
  [label]="label"
  [savingLabel]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.CustomerPrintTemplate.Storing' | translate"
  [group]="formGroup"
  [model]="model"
  [submitButtonDisabled]="submitButtonDisabled()"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <ssg-select
      name="otherPrintTempplateId"
      (valueChange)="valueChanges()"
      class="peymenttype"
      [group]="formGroup"
      userClass="select-md"
      [dataList]="otherCustomerPrintTemplates"
      [label]="'ClientApp.FrontOffice.PrintPolicy.PrintTemplate' | translate"
      textFieldName="Title"
      valueFieldName="Id">
    </ssg-select>
  </ng-container>
</dynamic-form>
